import logo from './logo.svg';
import './App.css';

function App() {
  const RedirectHandler = () => {
    window.location.href = "deeplink://deeplink.com/secondwebview";
  };

  return (
    <div className="App">
     

      <button onClick={RedirectHandler} >Redirect</button>
    </div>
  );
}

export default App;
